import CommentList from './components/CommentList'
import FileUploadButton from './components/buttons/FileUploadButton'
import findEnglishVideo from './utils/findEnglishVideo'
import HighlightOverlayContainer from './containers/HighlightOverlayContainer'
import ImageClipMain from './components/ImageClipMain'
import ImageResponseMain from './components/ImageResponseMain'
import JoinLiveModalContainer, {
  JOIN_LIVE_MODAL_ID
} from './containers/JoinLiveModalContainer'
import Paginator from './components/Paginator'
import ParticipantList from './components/ParticipantList'
import ReportOverlayContainer from './containers/ReportOverlayContainer'
import RestrictedWorkspacesWidget from './components/RestrictedWorkspacesWidget'
import TextClipMain from './components/TextClipMain'
import TextResponseMain from './components/TextResponseMain'
import TranscriptSelection from './components/TranscriptSelection'
import Video from './components/Video'
import VideoClipMain from './components/VideoClipMain'
import VideoClipPlayer from './components/VideoClipPlayer'
import VideoResponseMain from './components/VideoResponseMain'
import configureStore from './store/configureStore'
import renderWithTheme from './utils/renderWithTheme'
import { KeyCodes } from './constants/appConstants'
import { offsetsAtTime } from './utils/timeOffsetHelper'
import { buildAPIBaseURL, buildBaseURL } from './utils/urlHelper'
import renderComponent from './utils/renderComponent'
import renderContainer from './utils/renderContainer'
import { camelizeKeys } from 'humps'
import { createAlert } from './actions/alertActions'
import { createSearch } from './actions/searchActions'
import { openModal } from './actions/modalActions'
import {
  hasPermission,
  hasPermissionWithPermissions
} from './utils/hasPermission'
import ProTooltip from './components/ProTooltip'
import AdvancedSearchLink, {
  LockBadge,
  CollectionStatusLink
} from './components/TooltipBaseLink'

const store = configureStore(camelizeKeys(window.REDUX_DATA))

window.Tru = window.Tru || {}

window.Tru.Components = {
  ImageClipMain,
  ParticipantList,
  TextClipMain
}

// Actions
window.Tru.Actions = {
  createSearch,
  createAlert: alert => store.dispatch(createAlert(alert)),
  openJoinLiveModal: () => store.dispatch(openModal(JOIN_LIVE_MODAL_ID))
}

// Stores
window.Tru.Stores = {
  reduxStore: store
}

// Utilities
window.Tru.Utils = {
  buildAPIBaseURL,
  buildBaseURL,
  offsetsAtTime,
  findEnglishVideo,
  KeyCodes,
  hasPermission,
  hasPermissionWithPermissions
}

// Render Helpers
window.renderHighlightOverlay = renderContainer(
  store,
  HighlightOverlayContainer
)
window.renderPaginator = renderComponent(Paginator)
window.renderReportOverlay = renderContainer(store, ReportOverlayContainer)
window.renderVideo = renderComponent(Video)
window.renderVideoClipPlayer = renderContainer(store, VideoClipPlayer)
window.renderFileUploadButton = renderComponent(FileUploadButton)
window.renderCommentList = renderContainer(store, CommentList)
window.renderTranscriptSelection = renderComponent(TranscriptSelection)
window.renderJoinLiveModal = renderContainer(store, JoinLiveModalContainer)
window.renderVideoResponseMain = renderContainer(store, VideoResponseMain)
window.renderImageResponseMain = renderContainer(store, ImageResponseMain)
window.renderTextResponseMain = renderContainer(store, TextResponseMain)
window.renderVideoClipMain = renderContainer(store, VideoClipMain)
window.renderTooltip = renderWithTheme(ProTooltip)
window.renderAdvancedSearchLink = AdvancedSearchLink
window.renderLockBadge = renderWithTheme(LockBadge)
window.renderCollectionStatusLink = CollectionStatusLink
window.renderRestrictedWorkspacesWidget = renderWithTheme(
  RestrictedWorkspacesWidget
)



// WEBPACK FOOTER //
// ../src/app-entry.js